module.exports = __webpack_public_path__ + "img/LogoRedesign_DrThumm_RZ_rgb.e90255c4.png";